import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home/Home";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Contactus from "./pages/Contactus/Contactus";
import Blog from "./pages/Blog/Blog";
import Joinus from "./pages/Joinus/projects";
import BottomLink from "./components/BottomLink/BottomLink";
import Evcharger from "./pages/Evcharger/Evcharger";
import { HelmetProvider } from "react-helmet-async";
import BlogDetail from "./pages/Blog/BlogDetails";
import Aboutus from "./pages/Aboutus/Aboutus";
import ElectricalInstallation from "./pages/Services/ElectricalInstallation";
import Modifications from "./pages/Services/Modifications";
import PowerUpgrades from "./pages/Services/PowerUpgrades";
import ElectricalSolutions from "./pages/Services/ElectricalSolutions";

function App() {
  return (
    <div>
      
      <Header />
      <HelmetProvider>

      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />
        <Route path="/projects" element={<Joinus />} />
       <Route path="/evcharger" element={<Evcharger/>}/>
       <Route path="/electricalinstallation" element={<ElectricalInstallation/>}/>
       <Route path="/modifications" element={<Modifications/>}/>
       <Route path="/powerupgrades" element={<PowerUpgrades/>}/>
       <Route path="/electricalsolutions" element={<ElectricalSolutions/>}/>

       
       
    
      </Routes>
      </HelmetProvider>
      <BottomLink />
      <Footer />
    </div>
  );
}

export default App;
